// extracted by mini-css-extract-plugin
export default {"mainWrapper":"mainView_mainWrapper__Q-nKb","employeesList":"mainView_employeesList__Utt9C","projectList":"mainView_projectList__gQF6h"};